import React from 'react'
import { Form } from 'react-bootstrap'

const DateTimePicker = ({ value, onChange, disabled = false, isInvalid = null, minDate = null }) => {
  const formatDateTime = date => {
    if (!date) return ''
    const d = new Date(date)
    // Formatta la data nel formato "YYYY-MM-DDTHH:MM"
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    const hours = String(d.getHours()).padStart(2, '0')
    const minutes = String(d.getMinutes()).padStart(2, '0')

    return `${year}-${month}-${day}T${hours}:${minutes}`
  }

  const handleDateTimeChange = e => {
    if (onChange) {
      onChange(e.target.value)
    }
  }

  return (
    <Form.Control
      type="datetime-local"
      id="datetime"
      name="datetime"
      min={minDate ? minDate.toISOString().slice(0, 16) : null}
      value={formatDateTime(value)}
      onChange={handleDateTimeChange}
      disabled={disabled}
      isInvalid={isInvalid}
    />
  )
}

export default DateTimePicker
